import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const MetaPixelTrackerFB = () => {
  const location = useLocation();
  const pixelLoaded = useRef(false);

  useEffect(() => {
    // Routes where Meta Pixel should fire (FB flow)
    const fbRoutes = [
      '/fb',
      '/submit-task-fb',
      '/payment-processing-fb',
      '/payment-success-fb',
    ];

    // Check if current route is in FB routes
    if (!fbRoutes.includes(location.pathname)) {
      return;
    }

    // Only load pixel once
    if (pixelLoaded.current) {
      return;
    }

    pixelLoaded.current = true;

    // Insert Meta Pixel script into the page
    const script = document.createElement('script');
    const isPaymentSuccessPage = location.pathname === '/payment-success-fb';
    const pageViewEvent = !isPaymentSuccessPage ? `fbq('track', 'PageView');` : '';
    const leadEvent = isPaymentSuccessPage ? `fbq('track', 'Lead');` : '';
    
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1229993361859007');
      ${pageViewEvent}
      ${leadEvent}
    `;
    document.head.appendChild(script);

    // Insert noscript fallback
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `
      <img height="1" width="1" style="display:none"
      src="https://www.facebook.com/tr?id=1229993361859007&ev=PageView&noscript=1"
      />
    `;
    document.head.appendChild(noscript);

  }, [location.pathname]);

  return null;
};

export default MetaPixelTrackerFB;
